<template>
  <component
    :is="dialog ? 'q-dialog' : 'div'"
    v-model="shown"
    :maximized="$q.screen.lt.sm && dialog"
    data-test-id="featured-items"
  >
    <q-card
      :class="{ 'bg-transparent no-shadow q-py-sm': !dialog }"
      :style="$q.screen.lt.sm || !dialog ? undefined : 'width: 700px; max-width: 1000px'"
    >
      <q-card-section
        class="row items-center q-py-none"
        :class="{ 'q-px-none': !dialog && $q.screen.gt.xs && $isLandscapeView() }"
      >
        <div
          class="text-h6 text-center"
          style="line-height: 1.5;"
        >
          {{ $t('user.pickedForYou') }}
        </div>
        <q-space />
        <q-btn
          v-if="dialog"
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section
        :class="{
          'q-px-none': !dialog && $q.screen.gt.xs && $isLandscapeView(),
          'q-pl-sm q-pr-md': !dialog && $q.screen.lt.sm
        }"
      >
        <div
          class="row q-gutter-md justify-start content-start scroll"
        >
          <featured-item-card
            v-for="item in featuredItems"
            :key="item.id"
            :item="item"
            :order="order"
            :dialog="dialog"
            :shown="shown"
          />
        </div>
      </q-card-section>
    </q-card>
  </component>
</template>

<script>
import FeaturedItemCard from 'src/modules/checkout/components/FeaturedItemCard'

export default {
  name: 'FeaturedItems',
  components: {
    FeaturedItemCard
  },
  props: {
    modelValue: {
      type: Boolean,
      required: false
    },
    order: {
      type: Object,
      required: true
    },
    featuredItems: {
      type: Array,
      required: true
    },
    dialog: {
      type: Boolean,
      required: false,
      default: true
    },
    availableOnline: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      shown: true
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
      if (this.shown && this.category) {
        this.$trackPage(this, { category: this.category.name })
      }
    }
  },
  methods: {
    show () {
      this.shown = true
    }
  }
}
</script>
